import React from 'react';
import TabPane from './TabPane';

import './Tabs.scss';

export interface TabsProps {
  children: React.ReactNode;
  defaultActive?: string;
  onChange?: (key: string) => void;
  contentStyle?: any;
}

export interface TabsState {
  active: null | string;
}

export default class Tabs extends React.Component<TabsProps> {

  state = {
    active: `.$${this.props.defaultActive}`
  }

  render() {
    let { active } = this.state;
    let { children, defaultActive } = this.props;
    if (active === null) {
      active = defaultActive;
    }
    children = React.Children.toArray(children);
    const child = (children as TabPane[]).find((x: any) => x.key === active);
    return (
      <div className="tabs-component">
        <div className="tabs-bar">
          <ul>
            {React.Children.map(children as TabPane[], (ch: any) => (
              <li
                key={ch.key}
                onClick={this.handleChange.bind(this, ch.key)}
                className={ch.key === active ? 'active' : ''}>
                {ch.props.text}
              </li>
            ))}
          </ul>
        </div>
        <div className="tabs-content-wrapper" style={this.props.contentStyle}>
          {child}
        </div>
      </div>
    );
  }

  protected handleChange = (key: string) => {
    this.setState({ active: key });
  }

}
